import React from "react";
// import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { DetailFormMain, FormPart } from "../customer/styles/DetailFormStyles";
import AuthInput from "../../shared/authinput";
// import MainButton from "../../shared/Button";
import { DocumentsMain } from "./styles/VehicleStyles";
// import Vehicledoc from "../../../assets/images/Vehicledoc.png";
import { formatDate } from "../../../helpers/formatTime";
import NotFoundIcon from "../../shared/NotFoundIcon";

// const validationSchema = Yup.object().shape({
//   FullName: Yup.string().required("Full Name required"),
//   LicenseNumber: Yup.string().required("License Number required"),
//   LicenseValidity: Yup.string().required("License Validity required"),
// });

const LicenseDetails = ({ data = {} }) => {
  const handleSubmit = (values) => {
    console.log("values", values);
  };

  const initialValues = {
    FullName: data?.name || "",
    LicenseNumber: data?.license_number || "",
    LicenseValidity: formatDate(data?.validity || ""),
  };
  return (
    <>
      {data && Object?.keys(data)?.length > 0 ? (
        <DetailFormMain changeWidth={true}>
          <FormPart>
            <Formik
              initialValues={initialValues}
              // validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form autocomplete="off">
                  <div className="FormItem">
                    <Field
                      type="text"
                      name="FullName"
                      label="Full Name"
                      component={AuthInput}
                      placeholder="Enter Full Name"
                      disabled
                    />
                    <Field
                      type="text"
                      name="LicenseNumber"
                      label="License Number"
                      component={AuthInput}
                      placeholder="Enter License Number"
                      disabled
                    />
                  </div>
                  <div className="FormItem ">
                    <Field
                      type="text"
                      name="LicenseValidity"
                      label="License Validity"
                      component={AuthInput}
                      placeholder="Enter License Validity"
                      disabled
                    />
                  </div>
                  <DocumentsMain>
                    <h6>Documents</h6>
                    <div className="DocumentsWrapper">
                      {data?.document_urls?.map((value) => (
                        <img
                          src={value?.url}
                          key={value?.id}
                          alt="Vehicledoc"
                        />
                      ))}
                    </div>
                  </DocumentsMain>

                  {/* <div className="ButtonMain">
                  <MainButton type="submit" label="Approve" MT="90" />
                  <MainButton
                    type="button"
                    label="Reject"
                    MT="90"
                    border={true}
                  />
                </div> */}
                </Form>
              )}
            </Formik>
          </FormPart>
        </DetailFormMain>
      ) : (
        <NotFoundIcon MT="20" IconWidth="10" />
      )}
    </>
  );
};

export default LicenseDetails;
